export const countryCodes = [
    { country: 'India', code: '91' },
    { country: 'United States', code: '1' },
    { country: 'United Kingdom', code: '44' },
    { country: 'Canada', code: '1' },
    { country: 'Germany', code: '49' },
    { country: 'France', code: '33' },
    { country: 'Russia', code: '7' },
    { country: 'Brazil', code: '55' },
    { country: 'Australia', code: '61' },
    { country: 'Indonesia', code: '62' },
    { country: 'Pakistan', code: '92' },
    { country: 'Bangladesh', code: '880' },
    { country: 'Mexico', code: '52' },
    { country: 'Japan', code: '81' },
    { country: 'South Korea', code: '82' },
    { country: 'South Africa', code: '27' },
    { country: 'Nigeria', code: '234' },
    { country: 'Philippines', code: '63' },
];
